import * as React from "react";
import { IconProps } from "./IconProps";

export const IconChevronRight = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="Action / Up-down varient">
          <path
            id="Icon (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.52851 13.8047C5.26816 13.5444 5.26816 13.1223 5.52851 12.8619L10.3904 7.99999L5.52851 3.13807C5.26816 2.87772 5.26816 2.45561 5.52851 2.19526C5.78886 1.93491 6.21097 1.93491 6.47132 2.19526L11.8047 7.52858C11.9297 7.65361 11.9999 7.82318 11.9999 7.99999C11.9999 8.1768 11.9297 8.34637 11.8047 8.47139L6.47132 13.8047C6.21097 14.0651 5.78886 14.0651 5.52851 13.8047Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
